import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-1 text-black text-base leading-[20px]" }

import { useI18n } from "vue-i18n";



export default /*@__PURE__*/_defineComponent({
  __name: 'AddOutlineButton',
  props: {
    btnWidth: { default: "w-[125px]" },
    btnTextKey: { default: "buttons.add" }
  },
  emits: ["clicked"],
  setup(__props: any) {

const { t } = useI18n();





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["flex items-center gap-[10px] h-11 px-[10px] rounded-lg border border-brown", __props.btnWidth]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clicked')))
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      _createElementVNode("path", {
        d: "M9.99984 4.16797V15.8346M4.1665 10.0013H15.8332",
        stroke: "#1E1E1E",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)),
    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)(__props.btnTextKey)), 1)
  ], 2))
}
}

})